import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AsyncStateStatus } from '../root.types'
import { AuthState } from './types'

const initialState: AuthState = {
    login: {
        status: AsyncStateStatus.INITIAL
    },
    replace: {
        status: AsyncStateStatus.INITIAL
    },
    forgot: {
        status: AsyncStateStatus.INITIAL
    },
    loginTfa: {
        status: AsyncStateStatus.INITIAL
    },
    setupTfa: {
        status: AsyncStateStatus.INITIAL,
        data: null
    }
}

export const authSlice = createSlice({
    name: '@auth',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        loginReset: (state: AuthState) => {
            state.login = initialState.login
        },
        loginRequest: (state: AuthState) => {
            state.login.status = AsyncStateStatus.LOADING
        },
        loginSuccess: (state: AuthState) => {
            state.login.status = AsyncStateStatus.SUCCESS
        },
        loginFailure: (state: AuthState) => {
            state.login.status = AsyncStateStatus.FAILURE
        },
        replacePassword: (state: AuthState) => {
            state.replace.status = AsyncStateStatus.LOADING
        },
        replacePasswordSucess: (state: AuthState) => {
            state.replace.status = AsyncStateStatus.SUCCESS
        },
        replacePasswordFailure: (state: AuthState) => {
            state.replace.status = AsyncStateStatus.FAILURE
        },
        forgotPassword: (state: AuthState) => {
            state.forgot.status = AsyncStateStatus.LOADING
        },
        forgotPasswordSucess: (state: AuthState) => {
            state.forgot.status = AsyncStateStatus.SUCCESS
        },
        forgotPasswordFailure: (state: AuthState) => {
            state.forgot.status = AsyncStateStatus.FAILURE
        },
        loginTfa: (state: AuthState) => {
            state.loginTfa.status = AsyncStateStatus.LOADING
        },
        loginTfaSuccess: (state: AuthState) => {
            state.loginTfa.status = AsyncStateStatus.SUCCESS
            window.location.reload()
        },
        loginTfaFailure: (state: AuthState) => {
            state.loginTfa.status = AsyncStateStatus.FAILURE
        },
        setupTfa: (state: AuthState) => {
            state.setupTfa.status = AsyncStateStatus.LOADING
        },
        setupTfaSuccess: (state: AuthState, action: PayloadAction<{ data: any }>) => {
            state.setupTfa.status = AsyncStateStatus.SUCCESS
            state.setupTfa.data = action.payload.data
        },
        setupTfaFailure: (state: AuthState) => {
            state.setupTfa.status = AsyncStateStatus.FAILURE
        },
    }
})

/**
 * <h5>Functions that trigger actions related to authentication in the system.</h5>
 * @see {@link https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers#designing-actions}
 * @typedef AuthActions
 * @namespace AuthActions
 * @category React
 * @subcategory Redux / Actions
 * @property {Function} loginReset
 * @property {Function} loginRequest
 * @property {Function} loginSuccess
 * @property {Function} loginFailure
 */
export const AuthActions = authSlice.actions

export default authSlice.reducer
